const getRecaptchaSiteKey = () => {
	return window.REACT_APP_GOOGLE_RECAPTCHA_KEY
}

export default getRecaptchaSiteKey
